export default "__VITE_ASSET__BDgJQyeq__"